

<app-sidebar></app-sidebar>

<div class="content-container">
  <div class="container-fluid">
    <!-- Main component for a primary marketing message or call to action -->
    <div class="main-area d-flex">
      <div class="j-b w-100">
        <div id="r-p" class="title">Overview</div>
        <div class="tray1">
          <div class="text-green p">Active</div>
          <div class="p">
            <img src="assets/notifi.svg" alt="" />
          </div>
          <div class="border p-p ml-4 profile">
            <img src="assets/d-proflie.svg" alt="" />
            Arun Sarathy
          </div>
        </div>
      </div>
    </div>

    <div class="cards">
      <div class="w-100 col-12 col-md-6 col-xl-3">
        <div class="p-4 card">
          <div class="subtitle">User ID</div>
          <div class="text-pink text-center py text-hero">14001</div>
        </div>
      </div>

      <div class="w-100 col-12 col-md-6 col-xl-3 mt-2">
        <div class="p-4 mb-2 card">
          <div class="subtitle">Current Plan</div>
          <div class="text-pink py text-center text-hero">449</div>
        </div>
      </div>

      <div class="w-100 col-12 col-md-6 col-xl-3">
        <div class="p-4 mb-2 card">
          <div class="subtitle">Plan Validity</div>
          <div class="text-pink py text-center text-hero">60</div>
        </div>
      </div>

      <div class="col-12 w-100 col-md-6 col-xl-3">
        <div class="p-4 mb-2 card">
          <div class="subtitle">Plan Remaining Days</div>
          <div class="text-pink py text-center text-hero">22</div>
        </div>
      </div>
    </div>

    <div class="tray">
      <div class="d-block">
        <div class="card2 pr-4">
          <div class="sub-title">Data Usage Analytics</div>

          <div class="row text-center">
            <div class="col-md-6">
              <div class="main-area">
                <div class="">
                  <h4 class="title">35%</h4>
                  <p class="small-card-text">62.64 GB</p>
                  <div class="small-card-text-footer">Data Used</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="main-area">
                <div class="">
                  <h4 class="title">72%</h4>
                  <p class="small-card-text">330.65 GB</p>
                  <div class="small-card-text-footer">Data Reamining</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="main-area">
                <div class="">
                  <h4 class="title">95%</h4>
                  <p class="small-card-text">400 GB</p>
                  <div class="small-card-text-footer">Total Data</div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="main-area">
                <div class="">
                  <h4 class="title">100%</h4>
                  <p class="small-card-text">0.00 KB</p>
                  <div class="small-card-text-footer">Additional FUP</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="">
        <div class="card2 pl-4">
          <div class="sub-title">User Details</div>
          <div class="title">Arun Sarathy</div>
          <div class="h-100">
            <div class="md-d-flex strech-2 h-100">
              <div class="col-md-6  col-12 prof-detail h-100">
                <div class="">
                  <img src="assets/d1.svg" alt="" />
                  <span class="pl-8">Arunkumar</span>
                </div>
                <div class="">
                  <img src="assets/d2.svg" alt="" />
                  <span class="pl-8">9994768445</span>
                </div>
                <div class="">
                  <img src="assets/d3.svg" alt="" />
                  <span class="pl-8">Panruti</span>
                </div>
                <div class="">
                  <img src="assets/d4.svg" alt="" />
                  <span class="pl-8">Home</span>
                </div>
                <div class="">
                  <img src="assets/d5.svg" alt="" />
                  <span class="pl-8">May 30, 2021</span>
                </div>
              </div>
              <div class="col-md-6 col-12 mx-auto">
                <img src="assets/ashpropf.svg" class="img-fluid " alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
